function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M35 0C28.0777 0 21.3108 2.05271 15.5551 5.89856C9.79933 9.74441 5.3133 15.2107 2.66423 21.6061C0.015165 28.0015 -0.677952 35.0388 0.672531 41.8282C2.02301 48.6175 5.35644 54.8539 10.2513 59.7487C15.1461 64.6436 21.3825 67.977 28.1718 69.3275C34.9612 70.6779 41.9985 69.9848 48.3939 67.3358C54.7893 64.6867 60.2556 60.2007 64.1014 54.4449C67.9473 48.6892 70 41.9223 70 35C69.9902 25.7204 66.2996 16.8237 59.7379 10.2621C53.1763 3.70043 44.2796 0.00979939 35 0ZM48.4615 37.6923H21.5385C20.8244 37.6923 20.1396 37.4086 19.6347 36.9037C19.1298 36.3988 18.8462 35.714 18.8462 35C18.8462 34.2859 19.1298 33.6011 19.6347 33.0962C20.1396 32.5913 20.8244 32.3077 21.5385 32.3077H48.4615C49.1756 32.3077 49.8604 32.5913 50.3653 33.0962C50.8702 33.6011 51.1538 34.2859 51.1538 35C51.1538 35.714 50.8702 36.3988 50.3653 36.9037C49.8604 37.4086 49.1756 37.6923 48.4615 37.6923Z",
    fill: "#CD3546",
    style: {
      fill: "#CD3546",
      fill: "color(display-p3 0.8039 0.2078 0.2745)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossmark);
export default __webpack_public_path__ + "static/media/crossmark.e5ad414bc2dfdf33151ffae3eb8ac490.svg";
export { ForwardRef as ReactComponent };